export default __webpack_public_path__ + "static/carousel-hero-classic-2x-6bb0d48a809b7ab0ed90f49c0f7032ee.png";